import React from "react";
import {
  StethoscopeIcon,
  BabyIcon,
  DermatologyIcon,
  ToothIcon,
  BrainIcon,
  HeartIcon,
} from "./components/icons/MedicalIcons";
import {
  type Service,
  type Specialist,
  type Testimonial,
  type BlogPost,
  type FAQ,
} from "./types";

export const THEME_CONFIG = {
  font: "Inter",
  clinicName: "Salud Integral",
};

export const SERVICES_DATA: Service[] = [
  {
    // FIX: Replaced JSX with React.createElement to be valid in a .ts file.
    icon: React.createElement(StethoscopeIcon),
    name: "Medicina General",
    description:
      "Atención primaria integral para toda la familia, enfocada en la prevención y tratamiento de enfermedades comunes.",
  },
  {
    // FIX: Replaced JSX with React.createElement to be valid in a .ts file.
    icon: React.createElement(BabyIcon),
    name: "Pediatría",
    description:
      "Cuidado especializado para bebés, niños y adolescentes, monitoreando su crecimiento y desarrollo saludable.",
  },
  {
    // FIX: Replaced JSX with React.createElement to be valid in a .ts file.
    icon: React.createElement(DermatologyIcon),
    name: "Dermatología",
    description:
      "Diagnóstico y tratamiento de enfermedades de la piel, cabello y uñas, con enfoque en salud y estética.",
  },
  {
    // FIX: Replaced JSX with React.createElement to be valid in a .ts file.
    icon: React.createElement(ToothIcon),
    name: "Odontología",
    description:
      "Salud bucal completa, desde limpiezas preventivas y empastes hasta tratamientos de ortodoncia y estética dental.",
  },
  {
    // FIX: Replaced JSX with React.createElement to be valid in a .ts file.
    icon: React.createElement(BrainIcon),
    name: "Psicología",
    description:
      "Apoyo para la salud mental y el bienestar emocional, ofreciendo terapia individual, de pareja y familiar.",
  },
  {
    // FIX: Replaced JSX with React.createElement to be valid in a .ts file.
    icon: React.createElement(HeartIcon),
    name: "Cardiología",
    description:
      "Prevención, diagnóstico y tratamiento de enfermedades del corazón y del sistema circulatorio.",
  },
];

export const SPECIALISTS_DATA: Specialist[] = [
  {
    photo: "https://i.ibb.co/hJPtpPm6/pexels-jeff-denlea-721292-3714743.jpg",
    name: "Dra. Ana García",
    specialty: "Cardiología",
    experience: 15,
    bio: "Especialista en enfermedades cardiovasculares con enfoque en prevención y rehabilitación cardíaca.",
    socialLinks: { linkedin: "#" },
  },
  {
    photo: "https://i.ibb.co/hbDWKdD/pexels-tima-miroshnichenko-5452293.jpg",
    name: "Dr. Carlos Martínez",
    specialty: "Pediatría",
    experience: 12,
    bio: "Apasionado por el cuidado infantil, con experiencia en neonatología y desarrollo temprano.",
    socialLinks: { linkedin: "#" },
  },
  {
    photo: "https://i.ibb.co/6RC4cxcj/pexels-shkrabaanthony-5215024.jpg",
    name: "Dra. Sofía Rodríguez",
    specialty: "Dermatología",
    experience: 10,
    bio: "Experta en dermatología clínica y cosmética, ayudando a los pacientes a lograr una piel sana y radiante.",
    socialLinks: { linkedin: "#", others: "#" },
  },
  {
    photo: "https://i.ibb.co/sp1WpmKj/pexels-rdne-6129118.jpg",
    name: "Dr. Javier López",
    specialty: "Odontología",
    experience: 18,
    bio: "Odontólogo general con especialización en implantes y estética dental, comprometido con la sonrisa de sus pacientes.",
    socialLinks: { linkedin: "#" },
  },
]; 

export const TESTIMONIALS_DATA: Testimonial[] = [
  {
    quote:
      "Excelente atención y empatía. La Dra. García me explicó todo con claridad y paciencia. Me sentí en muy buenas manos.",
    author: "Laura Pérez",
    age: 45,
    specialty: "Cardiología",
    rating: 5,
  },
  {
    quote:
      "El Dr. Martínez es maravilloso con los niños. Mi hijo le perdió el miedo al doctor gracias a él. ¡Totalmente recomendado!",
    author: "Marcos Sánchez",
    age: 34,
    specialty: "Pediatría",
    rating: 5,
  },
  {
    quote:
      "Resultados increíbles con mi tratamiento de piel. La Dra. Rodríguez es una profesional excepcional y muy amable.",
    author: "Elena Gómez",
    age: 29,
    specialty: "Dermatología",
    rating: 5,
  },
  {
    quote:
      "Nunca pensé que ir al dentista podría ser una experiencia tan positiva. El Dr. López y su equipo son fantásticos.",
    author: "Roberto Díaz",
    age: 52,
    specialty: "Odontología",
    rating: 5,
  },
];

export const BLOG_POSTS_DATA: BlogPost[] = [
  {
    image: "https://i.ibb.co/ZznzS6LC/pexels-puwadon-sang-ngern-2168173-5340280.jpg",
    title: "5 Hábitos para un Corazón Saludable",
    excerpt:
      "Descubre cómo pequeños cambios en tu día a día pueden tener un gran impacto en tu salud cardiovascular.",
  },
  {
    image: "https://i.ibb.co/PscMf72h/pexels-cpkhanal-20471645.jpg",
    title: "La Importancia de la Vacunación Infantil",
    excerpt:
      "Entiende por qué las vacunas son clave para proteger a tus hijos y a la comunidad de enfermedades graves.",
  },
  {
    image: "https://i.ibb.co/dJxtCYbr/pexels-arezu-sajadi-2150009698-34233828.jpg",
    title: "Mitos y Verdades sobre el Cuidado de la Piel",
    excerpt:
      "La Dra. Rodríguez desmiente los mitos más comunes y te da consejos prácticos para una piel radiante.",
  },
]; 



export const GALLERY_IMAGES: string[] = [
  "https://i.ibb.co/gGYMfXG/pexels-luis-ribeiro-246346110-34260030.jpg",
  "https://i.ibb.co/6cM8NdwD/pexels-shkrabaanthony-5214995.jpg",
  "https://i.ibb.co/Q7x4LsjF/pexels-shvetsa-3844581.jpg",
  "https://i.ibb.co/xt6fQjS1/pexels-cottonbro-7578803.jpg",
  "https://i.ibb.co/bMRcP5CY/pexels-pixabay-263337.jpg",
  "https://i.ibb.co/MqNxtnK/pexels-thirdman-5327656.jpg"
];

export const FAQ_DATA: FAQ[] = [
  {
    question: "¿Necesito una cita para ser atendido?",
    answer: "Recomendamos agendar una cita para asegurar que podamos atenderte sin esperas. Sin embargo, aceptamos pacientes sin cita previa según la disponibilidad de nuestros especialistas.",
  },
  {
    question: "¿Qué seguros médicos aceptan?",
    answer: "Aceptamos una amplia variedad de seguros médicos. Por favor, contáctanos con la información de tu seguro para confirmar la cobertura antes de tu visita.",
  },
  {
    question: "¿Ofrecen servicios de telemedicina?",
    answer: "Sí, ofrecemos consultas en línea para varias de nuestras especialidades. Puedes agendar una cita de telemedicina a través de nuestro portal de reservas o contactándonos directamente.",
  },
  {
    question: "¿Cuáles son sus horarios de atención?",
    answer: "Nuestro horario de atención es de Lunes a Viernes de 9:00 a 18:00 y los Sábados de 9:00 a 13:00. Para emergencias, por favor dirígete al hospital más cercano.",
  },
];